import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { Truncate } from '@bd/bdcore-utilities';

import { colors } from '../../styles';
import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
  @media(min-width: 992px) {
    padding: 50px 20px;
  }
  .PlanAbout_body {
    p {
      font-weight: 300;
      font-size: 15px;
      color: ${colors.color3};
      letter-spacing: 0;
      line-height: 28px;
      @media(min-width: 992px) {
        font-size: 17px;
        color: ${colors.text};
        line-height: 30px;
      }
      &:first-of-type {
        font-size: 18px;
        color: #000000;
        line-height: 32px;
        @media(min-width: 992px) {
          font-size: 21px;
          line-height: 40px;
        }
      }
    }
  }
  .Process_ReadMorebtn {
    font-weight: 700;
    font-size: 15px !important;
    text-transform: capitalize;
    color: ${colors.color1};
    letter-spacing: 0;
    line-height: 28px;
    @media(min-width: 992px) {
      font-size: 17px;
      line-height: 30px;
    }
    &:hover {
      text-decoration: none;
    }
  }
  .btn-link {
    background-color: transparent;
    padding: 0;
    margin: -25px 0 0;
    transition: all .3s ease-out;
    &:hover {
      text-decoration: none;
      color: ${colors.color1Darkest};
    }
  }
`;

function PlanAbout({ description }) {
  return (
    <div className={styles}>
      <AccordionToggle
        openOnId="features"
        button={({ contentVisible }) => (
          <div className="">
            <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Floor Plan Description</h3>
          </div>
        )}
      >
        <div className="container">
          <div className="PlanAbout_body">
            <Truncate
              value={description}
              nl2br
              words={220}
              button={<span className="Process_ReadMorebtn">Read More</span>}
            />
          </div>
        </div>
      </AccordionToggle>
    </div>
  );
}

PlanAbout.propTypes = {
  description: PropTypes.string.isRequired,
};

export default PlanAbout;



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanAbout.js